<template lang="html">
  <modal
    :scrollable="true"
    name="drawing-modal"
    top="120"
    height="auto"
    width="776"
    class="drawing-modal"
    @closed="closed"
    @opened="opened"
    @before-open="beforeOpen"
  >
    <div class="modal-container">
      <div class="padding-3x big-body bold">
        Building Footprint
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        <ShapeDrawing :aduDrawingPoints="aduDrawingPoints" @finish-drawing="finishDrawing" />
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
        <SymbiumButton
          text="Cancel"
          :onClick="close"
          :isSmall="true"
          :isDialog="true"
          kclass="cancel-btn"
        />
        <SymbiumButton
          text="Save"
          :onClick="save"
          :isSmall="true"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import ShapeDrawing from './ShapeDrawing.vue'
import DisableBodyScroll from 'src/mixins/DisableBodyScroll.js'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { ShapeDrawing, SymbiumButton },
  mixins: [DisableBodyScroll],
  data() {
    return {
      data: null,
      aduDrawingPoints: [],
    }
  },
  methods: {
    finishDrawing(data) {
      this.data = data;
    },
    save() {
      if (this.data.aduFootPrint) {
        this.$emit('save', this.data)
      }
      this.$modal.hide('drawing-modal')
    },
    close() {
      this.$modal.hide('drawing-modal')
    },
    beforeOpen(event) {
      this.aduDrawingPoints = event.params.aduDrawingPoints
    }
  }
}
</script>
<style lang="scss" scoped>
.cancel-btn {
  margin-right: 16px !important;
}

.modal-body {
  max-height: calc(100vh - 182px);
}
</style>
<style lang="scss">
.drawing-modal {
  .footer-helper {
    border: none;
    padding: 0;
  }
}
</style>